import Vue from "vue";
import Load from "./index.vue";
let LoadingConstructor = Vue.extend(Load);
let instance = new LoadingConstructor({
  el: document.createElement("div"),
});
LoadingConstructor.prototype.open = function() {
  document.body.appendChild(instance.$el);
};
LoadingConstructor.prototype.close = function() {
  const el = instance.$el;
  el.parentNode && el.parentNode.removeChild(el);
};
export default {
  open: instance.open,
  close: instance.close,
};

// export default {
//     open: instance.open
// };
